export default __webpack_public_path__ + "static/media/2395.1226ee7d.png";